import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Grid, Icon, InputText, Text, InputCheckbox, Picture, Card, Badge } from "~/components-shared";
import api from "~/lib/api";
import styled, { useTheme } from "styled-components";
const Sticky = styled.div`
  position: sticky;
  top: 0;
  z-index: 2;
`;
const MemberInviteCommunityForm = _ref => {
  let {
    watch,
    setValue,
    memberCommunityIds = []
  } = _ref;
  const {
    colors
  } = useTheme();
  const {
    t
  } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [communities, setCommunities] = useState([]);
  const communityId = watch("communityId");
  useEffect(() => {
    setLoading(true);
    api.fetchCommunities({
      offset: undefined,
      size: 12,
      filter: {
        query: searchQuery
      }
    }).then(response => {
      setCommunities(response.items);
    }).finally(() => {
      setLoading(false);
    });
  }, [searchQuery]);
  const handleSearch = query => {
    setSearchQuery(query);
  };
  const handleSelect = id => {
    if (!memberCommunityIds.includes(id)) {
      setValue("communityId", id);
    }
  };
  return /*#__PURE__*/React.createElement("fieldset", null, /*#__PURE__*/React.createElement(Sticky, null, /*#__PURE__*/React.createElement(InputText, {
    value: searchQuery,
    onChange: handleSearch,
    elemBefore: /*#__PURE__*/React.createElement(Icon, {
      src: loading ? "spinner" : "search",
      s: {
        mr: 2
      }
    }),
    placeholder: t("common.actions.search"),
    s: {
      mb: 6
    },
    clearButton: true
  })), communities.map(community => /*#__PURE__*/React.createElement(Card, {
    key: community.id,
    s: {
      mx: -3,
      px: 3,
      py: 3
    },
    onClick: !memberCommunityIds.includes(community.id) ? () => handleSelect(community.id) : undefined
  }, /*#__PURE__*/React.createElement(Grid, {
    gap: 5,
    cols: 3,
    template: "1.4rem 3.6rem 1fr auto",
    align: "center"
  }, /*#__PURE__*/React.createElement(InputCheckbox, {
    value: communityId === community.id,
    onChange: () => handleSelect(community.id),
    disabled: memberCommunityIds.includes(community.id)
  }), /*#__PURE__*/React.createElement(Picture, {
    width: "3.6rem",
    height: "3.6rem",
    border: "rounded",
    name: community.name,
    src: community.picture,
    color: community.color || colors.secondary.main,
    onClick: () => handleSelect(community.id),
    style: {
      cursor: "pointer"
    }
  }), /*#__PURE__*/React.createElement(Grid.Cell, {
    onClick: () => handleSelect(community.id),
    style: {
      cursor: "pointer"
    }
  }, /*#__PURE__*/React.createElement(Text, {
    weight: "semiBold",
    display: "block",
    fontSize: 4
  }, community.name), community.memberIds && /*#__PURE__*/React.createElement(Text, {
    element: "span",
    color: colors.text.secondary,
    weight: "regular",
    fontSize: 3.5
  }, /*#__PURE__*/React.createElement(Icon, {
    src: "people",
    scale: 3
  }), " ", community.memberIds.length, " ", /*#__PURE__*/React.createElement(Text, {
    element: "span",
    color: colors.secondary.main
  }, "(", community.activeMemberIds.length, ")"))), memberCommunityIds.includes(community.id) && /*#__PURE__*/React.createElement(Badge, {
    color: "grey"
  }, "already in")))));
};
export default MemberInviteCommunityForm;